import { Component, OnInit, Input } from '@angular/core';
import { APPCONFIG } from "../../config";
import { CurriculumUnit } from "../shared/curriculum-unit";
import { Syllabus } from "../shared/syllabus";
import { ObjectObservable } from "../../shared/base/object-observable";
import { Course } from "../../courses/shared/course";
import { MESSAGE_EDIT_SUCCESS, MESSAGE_COMMON_ERROR } from "../shared/message";
import { MatSnackBarConfig, MatSnackBar } from "@angular/material";

@Component({
  selector: 'app-syllabus-curriculum-edit',
  templateUrl: './syllabus-curriculum-edit.component.html',
  styleUrls: ['./syllabus-curriculum-edit.component.scss']
})
export class SyllabusCurriculumEditComponent implements OnInit {

  @Input() courseObservable: ObjectObservable<Course>;
  @Input() course: Course;
  AppConfig: any;

  constructor(
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

  async onSubmit(value: Syllabus) {
    try {
      this.course.syllabus = value;
      this.courseObservable.update(this.course);
      this.handleSuccess();
    } catch (e) {
      this.handleError(e);
      ;
    }
  }

  async addCurriculum() {
    try {
      const unit = new CurriculumUnit();

      if(!this.course.syllabus.curriculum){
        this.course.syllabus.curriculum = [];
      }

      this.course.syllabus.curriculum.push(unit);
      await this.courseObservable.update(this.course);
    } catch (e) {
      this.handleError(e);
    }
  }

  private handleSuccess() {
    this.openSnackBar(MESSAGE_EDIT_SUCCESS);
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }

  async removeCurriculumUnit(i: number) {
    try {
      this.course.syllabus.curriculum.splice(i, 1);
      await this.courseObservable.update(this.course);
      this.handleSuccess();
    }catch (e) {
      this.handleError(e);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-curriculum-edit/syllabus-curriculum-edit.component.ts